// extend libraries
import {
  Dcml,
  dcmlFormat as remoteDcmlFormat,
} from '@paywithextend/localization'
import { connect } from 'react-redux'
import { RootState } from 'src/redux/createRootReducer'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'

export const dcmlFormat = (locale: string, amount: number): string => {
  return remoteDcmlFormat(locale)(amount)
}

export default connect(
  (state: RootState) => ({
    locale: selectNullSafeLocaleFromState(state),
  }),
  {},
)(Dcml)
